export default class DesignConsistency {
  static init() {
    DesignConsistency.addSpacerClassToNecessaryRows();
    DesignConsistency.checkHeroChildrenContainerForComplexContent();
    DesignConsistency.addClassToParentOfHero();
    DesignConsistency.addClassToFooterIfLastRowHasBackground();
    DesignConsistency.checkSubsequentContentBlocks();
  }

  static addSpacerClassToNecessaryRows() {
    const preSelector = '.vc_row:not(.vc_row-no-padding) .vc_column-inner > .wpb_wrapper > ';
    const selector = `${preSelector} .no-spacer, ${preSelector} .gform_wrapper`;
    const baseClassName = 'add-spacer';

    $(selector).each((idx, element) => {
      let className = baseClassName;
      let containsQuoteLink = false;

      if (element.nextElementSibling && element.nextElementSibling.classList.contains('quote-link')) {
        containsQuoteLink = true;
      }

      const ancestors = $(element).parentsUntil('.vc_row:not(.vc_inner)');

      if (ancestors && ancestors.length > 0 && !ancestors.is('.adds-own-spacer')) {
        const oldestAncestorThatCouldBeChildOfRow = ancestors[ancestors.length - 1];

        if (oldestAncestorThatCouldBeChildOfRow) {
          const parent = $(oldestAncestorThatCouldBeChildOfRow).parent();

          if (parent && parent.hasClass('vc_row')) {
            if (containsQuoteLink && parent[0].hasAttribute('data-vc-full-width')) {
              className += ' add-spacer-vertical';
            }
            parent.addClass(className);
          }
        }
      }
    });
  }

  static checkHeroChildrenContainerForComplexContent() {
    const is2023BlogSingle = document.querySelector('body.single-post.blog-design-2023') !== null;

    if (is2023BlogSingle) {
      return;
    }
    
    const container = $('.hero-children-container');
    const noOfRows = container.find('.vc_row.vc_inner').length;
    const noOfColumns = container.find('.vc_row.vc_inner .wpb_column').length;

    if (noOfRows >= 1 && noOfColumns > 1) {
      container.removeClass('adds-own-spacer').addClass('complex-content');
    }
  }

  static addClassToParentOfHero() {
    const heros = document.querySelectorAll('.hero');

    if (!heros || !heros.length) {
      const body = document.querySelector('body');
      body.classList.add('page-has-no-hero');
      return;
    }

    heros.forEach((hero) => {
      if (hero.classList.contains('hero-with-video')) {
        return;
      }
      
      const curveFillColor = hero.style.getPropertyValue('--curve-fill-color');

      hero.parentElement.classList.add('has-hero');
      hero.parentElement.style.setProperty('--curve-fill-color', curveFillColor);
    });
  }

  static addClassToFooterIfLastRowHasBackground() {
    const lastTwoRows = document.querySelectorAll('main.main > .container > .wpb-content-wrapper > .vc_row:nth-last-child(-n+2)');
    const footer = document.querySelector('footer.footer');

    lastTwoRows.forEach((row) => {
      if (row.matches('.white-bg') || row.matches('.gray-bg') || row.matches('.green-bg')
        || row.matches('[data-vc-full-width=true].vc_row-has-fill')
        || row.querySelector('.has-hero[style*=--curve-fill-color]')
        || row.querySelector('.wpb_column:only-child .wpb_wrapper > .responsive-picture:only-child')) {
        row.classList.add('last-row-above-footer');
        footer.classList.add('no-margin-block-start');
      }
    });
  }

  static checkSubsequentContentBlocks() {
    const selector = '.content-block-wrap.add-block-padding';
    const blocks = document.querySelectorAll(selector);

    blocks.forEach((block) => {
      const parentRow = block.closest('.vc_row:not(.vc_inner)');

      if (!parentRow) {
        return;
      }
      
      const nextRow = parentRow.nextElementSibling;

      if (nextRow && nextRow.matches('.vc_row:not([class*=-bg])') && nextRow.querySelector(selector)) {
        block.style.setProperty('--padding-block-end', 0);
      }
    });
  }
}
